import React, {Component} from 'react';
import '../App.css';
import axios from 'axios';

import GetCalendar from './GetCalendar.js';
import GetScaricaApp from './GetScaricaApp.js';

import Adsense from './_adsense.js';

import {
    Redirect
} from 'react-router-dom'


import {
    ShareButtons,
    generateShareIcon
} from 'react-share';


const {
    FacebookShareButton,
    GooglePlusShareButton,
    TwitterShareButton,
} = ShareButtons;

const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');


class Detail extends Component {

    constructor(props) {
        super(props);
        this.state = {isLoading: true};


        this.PathName = window.location.pathname;
        this.Update = this.Update.bind(this);
        this.params = (this.props.route.match.params);


    }

    componentWillUpdate(nextProps, nextState) {

        if (window.location.pathname !== this.PathName) {
            this.PathName = window.location.pathname;
            this.params = (nextProps.route.match.params);
            this.Update();

        }
    }

    Update() {


        this.language = "en";
        this.language = global.api.ValidateLanguage(this.params.language);

        if (this.params.rif === "app") {

            let req = window.location.href.split("/");

            const type = global.api.GetPageRif(req[req.length - 1]);

            if (type === false) {
                this.setState((prevState, props) => {
                    return {isLoading: true};
                });

                return;
            }


            this.setState((prevState, props) => {
                return {isLoading: false, type: type};
            });

        }
        else {
            axios.get(global.api.url + this.language + '/Get/' + this.params.rif)
                .then(res => {

                    if (res['data'] === "") {
                        this.setState((prevState, props) => {
                            return {isLoading: false, redirect: true};
                        });
                    }
                    else {
                        this.setState((prevState, props) => {
                            return {isLoading: false, data: res['data']};
                        });
                    }
                })
                .catch(err => {
                    this.setState((prevState, props) => {
                        return {isLoading: false, redirect: true};
                    });
                });
        }
    }

    componentDidMount() {

        this.Update();

    }


    render() {

        if (this.state.isLoading === true) {
            return null;
        }

        if (this.state.redirect === true) {
            return <Redirect to={"/" + this.language}/>;
        }

        if (this.state.type === "calendar") {
            return <GetCalendar main={this} type={this.state.type}/>;
        }

        if (this.state.type === "scarica") {
            return <GetScaricaApp main={this} type={this.state.type}/>;
        }


        document.title = this.state.data.title;


        const shareButton =
            <div style={{display: "flex"}}>
                <FacebookShareButton url={window.location.href}
                                     style={{margin: "7px"}}>
                    <FacebookIcon size={32} round/>
                </FacebookShareButton>

                <TwitterShareButton url={window.location.href}
                                    style={{margin: "7px"}}>
                    <TwitterIcon size={32} round/>
                </TwitterShareButton>

                <GooglePlusShareButton
                    url={window.location.href}
                    style={{margin: "7px"}}>
                    <GooglePlusIcon size={32} round/>
                </GooglePlusShareButton>
            </div>;

        const bannerTop = (
            <div style={{width: '95%'}}>
                <Adsense
                    client={"ca-pub-5171039140785324"}
                    slot={"5605948111"}
                    format={"auto"}
                    style={{display: 'block', textalign: 'center'}}
                />
            </div>);

        const bannerBottom = (
            <div style={{width: '95%'}}>
                <Adsense
                    client={"ca-pub-5171039140785324"}
                    slot={"9667771618"}
                    format={"auto"}
                    style={{display: 'block', textalign: 'center'}}
                />
            </div>);

        return (
            <div className="ContentSpacer fadeIn detailContent card" ref={'content'}>
                <div
                    style={{
                        width: '100%',
                        height: '60vh',
                        backgroundImage: 'url(' + global.api.GetImage(this.state.data.image) + ')'
                    }}
                    className="Cover"
                />



                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    paddingBottom: '25px'
                }}>
                    {shareButton}

                    <div style={{
                        fontSize: "30px",
                        marginTop: "25px",
                        marginBottom: "20px",
                        textAlign: 'left'
                    }}>{this.state.data.title}</div>
                    {bannerTop}
                    <div className={"BodyText"}
                         style={{lineHeight: '32px', fontSize: "18px", textAlign: 'left'}}>{this.state.data.text}</div>

                    {shareButton}

                    {bannerBottom}
                </div>
            </div>

        );
    }
}

export default Detail;





// WEBPACK FOOTER //
// ./src/include/Detail.js